import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.699997 2.7498C0.699997 1.25864 1.90883 0.0498047 3.4 0.0498047H14.2C15.6912 0.0498047 16.9 1.25864 16.9 2.7498V16.2498C16.9 17.741 18.1088 18.9498 19.6 18.9498H3.4C1.90883 18.9498 0.699997 17.741 0.699997 16.2498V2.7498ZM4.75 4.0998H12.85V9.49981H4.75V4.0998ZM12.85 12.1998H4.75V14.8998H12.85V12.1998Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M18.25 5.44981H19.6C21.0912 5.44981 22.3 6.65864 22.3 8.14981V15.5748C22.3 16.6932 21.3934 17.5998 20.275 17.5998C19.1566 17.5998 18.25 16.6932 18.25 15.5748V5.44981Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }